import React from 'react';
import { CommentSection, RatingCard } from '../../organisms';
import {
  upselling,
  delivery,
  timebgyellow,
  india,
  network,
  price_drop_icon,
  WalletIcon
} from '../../../../assets/images';
import MetricCard from '../../atoms/MetricCard';
import { commaingNumber } from '../../../../utils';
import WalletUtilizationCommon from './WalletUtilizationCommon';

const Pharmacy = ({ metricObj, ratingObj, coverageObj, spentSavingsObj, loading, walletUtilizationObj, benefitName }) => {
  const { total_orders, average_tat, one_time_users, repeat_users } = metricObj;
  const { ratingsPercent, totalratings, averagerating, commentSectionData } = ratingObj;
  const { spend, savings } = spentSavingsObj;
  const { orders_delivered = {}, network_coverage = {} } = coverageObj;
  const { totalWalletAmount, walletEnable } = walletUtilizationObj;

  return (
    <div>
      <p className='text-gray-700 text-base font-semibold mt-8 mb-3 leading-none'>Pharmacy orders</p>
      <div className='flex flex-row justify-between'>
          { walletEnable && (totalWalletAmount > 0) && (<MetricCard
            loading={loading}
            loaderHeight={120}
            svgsrc={WalletIcon}
            titleClasses='font-semibold text-gray-800'
            title='Total amount added'
            subTitle='Total amount added for employee and dependent wallet utilization'
            metricClasses='flex mt-0 text-gray-500'
            metricValue={<span className='ml-10 font-semibold text-3xl text-gray-700'>₹{commaingNumber(totalWalletAmount)}</span>}
            classes='w-1/2 inline-block mr-5'
          />)}
        <MetricCard
          loading={loading}
          loaderHeight={120}
          svgsrc={delivery}
          titleClasses='font-semibold text-gray-800'
          title='Total orders delivered'
          subTitle='All orders delivered for self and dependents'
          metricClasses='flex mt-0 text-gray-500'
          metricValue={<span className='font-semibold text-3xl text-gray-700'>{commaingNumber(total_orders)}</span>}
          classes='w-1/2 inline-block mr-5'
        />
        <MetricCard
          loading={loading}
          loaderHeight={120}
          svgsrc={timebgyellow}
          titleClasses='font-semibold text-gray-800'
          title='Average delivery TAT'
          subTitle='average delivery turn around time'
          metricValue={<span className=' font-semibold  text-3xl text-gray-700'>{commaingNumber(average_tat)}</span>}
          metricValueSuffix='hours'
          metricClasses='flex mt-0 text-gray-500'
          classes='w-1/2 inline-block mr-5'
        />
      </div>

      <WalletUtilizationCommon metricObj={metricObj}  loading={loading} benefitName={benefitName} walletUtilizationObj={walletUtilizationObj} uniqueUsers={one_time_users} />

      <div className='flex flex-row justify-between mt-12'>
        <div className='flex flex-col w-1/2 mr-4'>
          <span className='text-gray-700 text-base font-semibold mb-3 leading-none'>
            Amount spent on pharmacy orders
          </span>
          <MetricCard
            loading={loading}
            loaderHeight={120}
            svgsrc={upselling}
            title='Total pharmacy order value '
            metricValue={<span className='font-semibold text-3xl text-gray-700'>₹{commaingNumber(spend)}</span>}
            classes='inline-block'
          />
        </div>
        <div className='flex flex-col w-1/2'>
          <span className='text-gray-700 text-base font-semibold mb-3 leading-none'>
            Amount saved on pharmacy by ekincare
          </span>
          <MetricCard
            loading={loading}
            loaderHeight={120}
            svgsrc={price_drop_icon}
            title='Saving provided by ekincare'
            metricValue={<span className='font-semibold text-3xl text-gray-700'>₹{commaingNumber(savings)}</span>}
            classes='inline-block'
          />
        </div>
      </div>

      <div className='flex flex-row justify-between mt-12'>
        <div className='flex flex-col w-1/2 mr-4'>
          <span className='text-gray-700 text-base font-semibold mb-3 leading-none'>
            Pharmacy orders delivered across
          </span>
          <MetricCard
            loading={loading}
            loaderHeight={120}
            svgsrc={india}
            title={
              <span>
                <span className='font-semibold'>{commaingNumber(total_orders)} orders</span> were delivered across{' '}
                {/*orders_delivered.orders || 0*/}
                <span className='font-semibold'> {orders_delivered.pincodes || 0} pincodes</span>
              </span>
            }
            classes='inline-block h-full'
            headerClasses='flex items-center'
          />
        </div>
        <div className='flex flex-col w-1/2'>
          <span className='text-gray-700 text-base font-semibold mb-3 leading-none'>
            ekincare pharmacy network coverage
          </span>
          <MetricCard
            loading={loading}
            loaderHeight={120}
            svgsrc={network}
            title={
              <span>
                With our partner servicing <span className='font-semibold'>25,000+ pincodes,</span> medicine orders will{' '}
                {/*network_coverage.pincodes || 0*/}
                be delivered pan India within <span className='font-semibold'>48 hours.</span>{' '}
                {/*network_coverage.time || 0*/}
              </span>
            }
            classes='inline-block'
          />
        </div>
      </div>

      <div className='flex flex-row mt-12'>
        <div className='flex flex-col w-2/4 pr-4'>
          <div className='text-base font-semibold leading-none text-gray-700 leading-none mb-1'>
            Ratings and Reviews
          </div>
          <div className='text-sm mb-3 leading-2 text-gray-600'>
            These ratings are captured after completing delivery of pharmacy.
          </div>
          <RatingCard
            loading={loading}
            loaderHeight={200}
            rating={averagerating}
            number_of_ratings={totalratings}
            five_star_rating={ratingsPercent && ratingsPercent[4]}
            four_star_rating={ratingsPercent && ratingsPercent[3]}
            three_star_rating={ratingsPercent && ratingsPercent[2]}
            two_star_rating={ratingsPercent && ratingsPercent[1]}
            one_star_rating={ratingsPercent && ratingsPercent[0]}
            classes='h-full'
          />
        </div>

        <div className='flex flex-col w-2/4'>
          <div className='text-base font-semibold leading-none text-gray-700 leading-none mb-1'>Top Comments</div>
          <div className='text-sm mb-3 leading-2 text-gray-600'>
            These reviews are captured after completing delivery of Pharmacy.
          </div>
          <CommentSection loading={loading} loaderHeight={200} points={commentSectionData} classes='h-full' />
        </div>
      </div>
    </div>
  );
};

export default Pharmacy;
